export default __webpack_public_path__ + "static/media/AftaSansThin-Regular.8dd09332.otf";